import { useAppDispatch } from 'src/app/store';
import { DropdownMenuItem } from 'src/common/DropdownMenu/DropdownMenuItem';
import {
  AssignmentRead,
  DispatchTripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

import { createEventsFromTrips } from '../createEventsFromTrips';
import { createEventsFromTripWaitTimes } from '../createEventsFromTripWaitTimes';
import { useTripMenuActions } from '../DispatchCalendar/useTripMenuActions';
import {
  addTempTripAssignment,
  onPreviewTripAssignmentEnd,
  onPreviewTripAssignmentStart,
  removeTempTripAssignment,
} from '../dispatcher.slice';

type DriverAssignmentMenuActionProps = {
  assignment: AssignmentRead;
  trip: DispatchTripRead;
};

export function DriverAssignmentMenuAction({
  assignment,
  trip,
}: DriverAssignmentMenuActionProps) {
  const dispatch = useAppDispatch();
  const menuActions = useTripMenuActions();

  const isAssigned = !!trip.assignment_id;

  return (
    <>
      <DropdownMenuItem
        key={assignment.id}
        onClick={() => {
          if (isAssigned) {
            menuActions.reassign(trip.id, assignment.id);
          } else {
            menuActions.assign(trip.id, assignment.id);
          }
        }}
        onMouseEnter={() => {
          const tempTrip = {
            ...trip,
            assignment_id: assignment.id,
            id: `${trip.id}-preview`,
          };
          if (trip.inbound_trip) {
            const previewEvents = [
              ...createEventsFromTrips([
                tempTrip,
                {
                  ...trip.inbound_trip,
                  assignment_id: assignment.id,
                  id: `${trip.inbound_trip.id}-preview`,
                } as DispatchTripRead,
              ]),
            ];
            if (trip.wait_time_start !== null && trip.wait_time_end !== null) {
              previewEvents.push({
                ...createEventsFromTripWaitTimes([tempTrip])[0],
                id: `${trip.id}-wait-preview`,
              });
            }

            dispatch(onPreviewTripAssignmentStart(previewEvents));
          } else {
            dispatch(addTempTripAssignment(tempTrip));
          }
        }}
        onMouseLeave={() => {
          if (trip.inbound_trip) {
            dispatch(onPreviewTripAssignmentEnd());
          } else {
            dispatch(removeTempTripAssignment(trip.id));
          }
        }}
      >
        {formatFullName(assignment.driver)}
      </DropdownMenuItem>
    </>
  );
}
